<template>
  <div>
    <p class="has-text-default is-italic">
      {{ $t('detailProduitSalon.regleFacturation.field') }}
    </p>
    <router-link-blank v-if="regleFacturationProduit"
                        :to="{ name: 'c.presse.regle_facturation-detail',
        params: {id: regleFacturationProduit.id}}"
                        :message="regleFacturationProduit.code + ' - '
                        + regleFacturationProduit.libelle + ' - '
      + $t(getTypeTraduit(regleFacturationProduit.type))"
    />
  </div>
</template>

<script>
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { createNamespacedHelpers } from 'vuex';
import {
  TYPE_REGLE_FACTURATION,
} from '@/configuration/presse/regleFacturation/regleFacturationConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'regleFacturation',
  props: {
    produit: {
      type: Object,
      required: false,
    },
  },
  components: {
    routerLinkBlank,
  },
  data() {
    return {
      listeTypeRegleFacturation: TYPE_REGLE_FACTURATION,
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    getRegleFacturation() {
      let societeId = this.societeActiveId;
      if (this.produit.id && this.produit?.supportCommercial?.societeId) {
        societeId = this.produit.supportCommercial.societeId;
      }
      return this.parametre(typesParametres.PARAMETRES_KEYS.regleFacturation)
        .filter(regle => regle.societeId === societeId);
    },
    regleFacturationProduit() {
      if (!this.produit?.regleFacturationId) return null;
      return this.getRegleFacturation.find(r => r.id === this.produit.regleFacturationId);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    getTypeTraduit(clef) {
      return (this.listeTypeRegleFacturation.find((el) => el.key === clef)).libelle;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([typesParametres.PARAMETRES_KEYS.regleFacturation]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
